import React, { useEffect, useState } from "react";
import {
  LabelInputWithIcon,
  FormControl,
  ButtonCommonTheme,
  Alert,
  Button,
} from "modules/theme";
import { Link } from "react-router-dom";
import { AuthBox } from "../../../../auth/styles";
import Turnstile from "./turnstile-react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import actionTypes from "../../../../../store/actionTypes";
import { FaGithub, FaMicrosoft } from "react-icons/fa";
import { FaWindows } from "react-icons/fa";
import SocialLogin from "../../../../auth/components/SocialLogin";
import { cloudFlareKey } from "../../../../../helpers/dotenv";

const AuthBoxLayout = (props) => {
  const {
    isAdminLogin,
    onSubmit,
    email,
    emailLabel = "Email Or Username",
    onEmailChange,
    onPassChange,
    password,
    forgotPassLink,
    BackBtnTitle,
    BackBtnClick,
    isLoading,
    onhandleTurnstileVerify,
    rememberMe,
    handleCheckboxChange,
    isVerified,
    dispatch,
    loginUrl,
    microsoftCheck,
    isCloudFlareEnable
  } = props;
  const [showPassword, setShowPassword] = useState(false);
  const history = useHistory();

  useEffect(() => {
    async function some() {
      if (isAdminLogin) {
        if (window.location.search) {
          try {
            const res = await fetch(
              `https://region-tl.streamspace.ai/global2/v1/auth/github${window.location.search}`
            );
            const response = await res.json();
            if (res.status >= 400 && res.status < 500)
              Alert.error(
                (response && response.message) || "Something went wrong"
              );
            dispatch({
              type: actionTypes.GLOBAL_DYNAMIC_UPDATE,
              payload: response.token,
            });
            localStorage.setItem("token", response.token);
            history.push("/dashboard");
          } catch (err) {
            Alert.error("Something went wrong");
          }
        }
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;
        script.addEventListener("error", () => {
          console.error("Login with google is temporarily unavailable");
        });
        document.head.appendChild(script);

        // GOOGLE OAUTH
        window.handleCredentialResponse = async (e) => {
          const headers = new Headers();
          headers.append("Content-Type", "application/json");
          const res = await fetch(
            "https://region-tl.streamspace.ai/global2/v1/auth/google",
            {
              headers,
              method: "POST",
              body: JSON.stringify(e),
            }
          );
          try {
            const response = await res.json();
            if ((res.status >= 400 && res.status < 500) || !response.token) {
              console.error("hemlo", response, res);
              return Alert.error(
                (response && response.message) || "Something went wrong"
              );
            }

            dispatch({
              type: actionTypes.GLOBAL_DYNAMIC_UPDATE,
              payload: response.token,
            });
            localStorage.setItem("token", response.token);

            history.push("/dashboard");
          } catch (err) {
            console.error("hemlo", err);
            Alert.error("Something went wrong");
          }
        };
      }
    }
    some();
    return () => {
      window.handleCredentialResponse = undefined;
    };
  }, []);

  return (
    <AuthBox className="mt-4 mb-4">
      <h2 className="authbox-title">Sign in</h2>
      <p className="authbox-desc">
        Please add below details to login in the system.
      </p>
      <form onSubmit={onSubmit}>
        <LabelInputWithIcon
          icon="email"
          label={emailLabel}
          value={email}
          onChange={onEmailChange}
          type="text"
          placeholder="Enter your email address"
          maxLength={70}
          iconProps={{
            style: { color: "#d9d9d9" },
          }}
        />
        <LabelInputWithIcon
          icon={showPassword ? "lock_open" : "lock"}
          iconProps={{
            onClick: () => setShowPassword(!showPassword),
            style: {
              cursor: "pointer",
              userSelect: "none",
              color: "#d9d9d9",
            },
          }}
          label="Password"
          value={password}
          onChange={onPassChange}
          type={showPassword ? "text" : "password"}
          placeholder="Enter Password"
        />
        <div className="flex-between">
          <div className="custom-checkbox">
            <FormControl
              componentClass="checkbox"
              checked={rememberMe}
              onChange={handleCheckboxChange}
            >
              <span>Remember me</span>
            </FormControl>
          </div>
          <Link className="blue-link" to={forgotPassLink}>
            Forgot Password?
          </Link>
        </div>
        {/* <ReCaptcha onVerify={onhandleTurnstileVerify} /> */}
        {isCloudFlareEnable && 
          (<div className="flex justify-center my-4">
            <Turnstile
              sitekey={cloudFlareKey}
              onVerify={onhandleTurnstileVerify}
              onError={() => {
                Alert.error("Something went wrong");
              }}
              theme="light"
              onTimeout={() => {
                Alert.error("Failed to verify!");
              }}
              onExpire={() => {
                Alert.error("Verification token expired!");
              }}
            />
          </div>
        )}

        {isAdminLogin && (
          <div className="flex justify-between items-center">
            <div
              id="g_id_onload"
              data-client_id="455856203379-qnr8pjb9qs4ml2816i3aoui74rdaulnr.apps.googleusercontent.com"
              data-callback="handleCredentialResponse"
            ></div>

            {/* <div className="g_id_signin" data-type="standard">
              <button
                type="button"
                className="flex items-center gap-2 px-4 py-3"
                style={{borderRadius: 10}}
              >
                <FcGoogle />
                Google Login
              </button>
            </div> */}
            {/* <button
              type="button"
              className="flex items-center gap-2 px-4 py-3"
              style={{borderRadius: 10}}
              onClick={(e) => {
                e.preventDefault();
                if (process.env.REACT_APP_GITHUB_OAUTH_URL) {
                  window.location.href = process.env.REACT_APP_GITHUB_OAUTH_URL;
                }
              }}
            >
              <FaGithub />
              Github Login
            </button> */}
          </div>
        )}
        <div className="flex-between mt-10">
          <ButtonCommonTheme
            btnTitle={BackBtnTitle}
            type="backIconBtn"
            onClick={BackBtnClick}
          />
          <ButtonCommonTheme
            type="nextIconBtn"
            btnType="submit"
            btnTitle="Sign In"
            disabled={isCloudFlareEnable && !isVerified}
            isLoading={isLoading}
          />
        </div>
        <div class="or">
          <hr class="bar" />
          <span>OR</span>
          <hr class="bar" />
        </div>
        <div className="w-100 text-center">
          {/* <Button
            btnStyle="link"
            size="xl"
            // icon="folder-download"
            target="_blank"
            onClick={microsoftCheck}
            className=" justify-content-center"
          >
            <FaWindows className="mr-3" />{" "}
            <div
              className="remove-text-on-925px"
              style={{ lineHeight: "21px", letterSpacing: "0.1em" }}
            >
              Sign In with Microsoft
            </div>
          </Button> */}
          <Button
            btnStyle="link"
            size="small"
            block
            className="lightbutton-btn justify-content-center"
            onClick={microsoftCheck}
            // className="grey-btn justify-content-center"
            // type="greyModalBtn"
          >
            {/* <span
              class="material-symbols-outlined fw-500"
              style={{ lineHeight: "21px" }}
            >
              add_circle
            </span> */}
            {/* <FaWindows className="mr-3" /> */}
            <img
              src="images/miscrosoft.svg"
              style={{ width: "20px", height: "auto", lineHeight: "21px" }}
              className="mr-4"
            />{" "}
            <div
              className="remove-text-on-925px"
              style={{ lineHeight: "21px" }}
            >
              Sign In with Microsoft
            </div>
          </Button>
          {/* <Button
            btnStyle="link"
            block
            style={{
              background: "#FAFAFA",
              border: "1px solid #EDE7F6",
            }}
          >
            <img
              src="images/miscrosoft.svg"
              style={{ width: "24px", height: "auto" }}
            />{" "}
            Sign In with Microsoft
          </Button> */}
        </div>
        {/* <Button type="primary" onClick={microsoftCheck}>
          Sign in with Microsoft
        </Button> */}
      </form>
    </AuthBox>
  );
};

export default connect()(AuthBoxLayout);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/AuthBoxLayout.jsx